import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const UpcomingMeetingCard = ({ meeting }) => {
  const getMeetingTypeColor = (type) => {
    const colors = {
      'Video Call': 'bg-primary/10 text-primary',
      'In-Person': 'bg-success/10 text-success',
      'Phone Call': 'bg-accent/10 text-accent',
      'Conference': 'bg-secondary/10 text-secondary'
    };
    return colors?.[type] || 'bg-muted text-muted-foreground';
  };

  const formatMeetingTime = (date, time) => {
    return `${date} at ${time}`;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5 hover:shadow-md transition-all duration-300">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex items-start gap-3 min-w-0 flex-1">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Video" size={20} className="md:w-6 md:h-6" color="var(--color-primary)" />
          </div>
          <div className="min-w-0 flex-1">
            <h4 className="text-sm md:text-base font-semibold text-foreground line-clamp-1 mb-1">
              {meeting?.title}
            </h4>
            <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${getMeetingTypeColor(meeting?.type)}`}>
              <Icon name={meeting?.type === 'Video Call' ? 'Video' : meeting?.type === 'Phone Call' ? 'Phone' : 'MapPin'} size={12} />
              {meeting?.type}
            </span>
          </div>
        </div>
      </div>
      <div className="space-y-3 mb-4">
        <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
          <Icon name="Calendar" size={14} className="flex-shrink-0" />
          <span>{formatMeetingTime(meeting?.date, meeting?.time)}</span>
        </div>

        <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
          <Icon name="Clock" size={14} className="flex-shrink-0" />
          <span>{meeting?.duration}</span>
        </div>

        {meeting?.location && (
          <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
            <Icon name="MapPin" size={14} className="flex-shrink-0" />
            <span className="line-clamp-1">{meeting?.location}</span>
          </div>
        )}
      </div>
      <div className="mb-4">
        <p className="text-xs text-muted-foreground mb-2">Participants</p>
        <div className="flex items-center gap-2">
          <div className="flex -space-x-2">
            {meeting?.participants?.slice(0, 4)?.map((participant, index) => (
              <Image
                key={index}
                src={participant?.avatar}
                alt={participant?.avatarAlt}
                className="w-7 h-7 md:w-8 md:h-8 rounded-full border-2 border-card object-cover"
              />
            ))}
          </div>
          {meeting?.participants?.length > 4 && (
            <span className="text-xs text-muted-foreground">
              +{meeting?.participants?.length - 4} more
            </span>
          )}
        </div>
      </div>
      <div className="flex gap-2">
        <Button variant="default" size="sm" fullWidth iconName="Video" iconPosition="left">
          Join Meeting
        </Button>
        <Button variant="outline" size="sm" iconName="Calendar" className="flex-shrink-0">
          <span className="sr-only">Add to Calendar</span>
        </Button>
      </div>
    </div>
  );
};

export default UpcomingMeetingCard;